<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>OPCR Targets</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <v-col cols="12" v-if="isSubmitted">
                <v-stepper alt-labels class="elevation-0">
                  <v-stepper-header>
                    <v-stepper-step
                      step="1"
                      class="pa-5"
                      :complete="
                        data && data.target_submission.imm_approval_status == 2
                          ? true
                          : false
                      "
                      :rules="[
                        () =>
                          data &&
                          data.target_submission.imm_approval_status != 3,
                      ]"
                      color="#6DB249"
                    >
                      <div style="width: 200px" class="text-center">
                        {{
                          data.target_submission.imm_head
                            ? getUserName(data.target_submission.imm_head)
                            : ""
                        }}
                      </div>
                      <small>Assessed By<br /> </small>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="2"
                      class="pa-5"
                      :complete="
                        data &&
                        data.target_submission.planning_user_approval_status ==
                          2
                          ? true
                          : false
                      "
                      :rules="[
                        () =>
                          data &&
                          data.target_submission
                            .planning_user_approval_status != 3,
                      ]"
                      color="#6DB249"
                    >
                      <div style="width: 200px" class="text-center">
                        {{
                          data.target_submission.planning_user_approver
                            ? getUserName(
                                data.target_submission.planning_user_approver
                              )
                            : ""
                        }}
                      </div>
                      <small>Planning <br /> </small>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="3"
                      class="pa-5"
                      :complete="
                        data && data.target_submission.cpmt_approval_status == 2
                          ? true
                          : false
                      "
                      :rules="[
                        () =>
                          data &&
                          data.target_submission.cpmt_approval_status != 3,
                      ]"
                      color="#6DB249"
                    >
                      <div style="width: 200px" class="text-center">
                        {{
                          data.target_submission.cpmt_approver
                            ? getUserName(data.target_submission.cpmt_approver)
                            : ""
                        }}
                      </div>
                      <small>CPMT <br /> </small>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="4"
                      class="pa-5"
                      :complete="
                        data &&
                        data.target_submission.president_approval_status == 2
                          ? true
                          : false
                      "
                      :rules="[
                        () =>
                          data &&
                          data.target_submission.president_approval_status != 3,
                      ]"
                      color="#6DB249"
                    >
                      <div style="width: 200px" class="text-center">
                        {{
                          data.target_submission.president_approver
                            ? getUserName(
                                data.target_submission.president_approver
                              )
                            : ""
                        }}
                      </div>
                      <small>President <br /> </small>
                    </v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </v-col>
              <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @change="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2" class="d-flex justify-end mt-2 mr-2">
                <v-btn
                  v-if="shouldSubmit() && tab == 1"
                  @click="AddFunction()"
                  class="white--text rounded-lg"
                  color="#519043"
                >
                  Add
                </v-btn>
              </v-col>
              <v-col cols="12" class="pt-2 px-4">
                <v-data-table
                  :headers="
                    tab == 1
                      ? cf_headers
                      : tab == 2
                      ? sp_headers
                      : support_headers
                  "
                  :items="dataItem"
                  :items-per-page="10"
                  :item-class="setPendingClass"
                >
                  <template v-slot:[`item.eqt`]="{ item }">
                    <div class="text-center">
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">E -</div>
                        <div class="align-self-center">
                          <v-icon v-if="item.eff_is_rated" color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.eff_is_rated" x-small>NR</v-chip>
                        </div>
                      </div>
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">Q -</div>
                        <div class="align-self-center">
                          <v-icon v-if="item.qly_is_rated" color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.qly_is_rated" x-small>NR</v-chip>
                        </div>
                      </div>
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">T -</div>

                        <div class="align-self-center">
                          <v-icon
                            v-if="item.timeliness_is_rated"
                            color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.timeliness_is_rated" x-small
                            >NR</v-chip
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.is_tagged`]="{ item }">
                    <v-chip
                      x-small
                      class="white--text"
                      :color="
                        item.OpcrPapTargetDistributedTaggingCount &&
                        (item.opcr_pap_target_distributed_tagging_ID ||
                          item.OpcrPapTargetDistributedTaggingID)
                          ? '#519043'
                          : 'warning'
                      "
                    >
                      {{
                        item.OpcrPapTargetDistributedTaggingCount &&
                        (item.opcr_pap_target_distributed_tagging_ID ||
                          item.OpcrPapTargetDistributedTaggingID)
                          ? "Yes"
                          : "No"
                      }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.alloted_budget`]="{ item }">
                    {{
                      item.alloted_budget
                        ? formatPrice(item.alloted_budget)
                        : ""
                    }}
                  </template>

                  <template v-slot:[`item.isDistributed`]="{ item }">
                    <v-chip
                      x-small
                      class="white--text"
                      :color="item.isDistributed ? '#519043' : 'warning'"
                    >
                      {{ item.isDistributed ? "Yes" : "No" }}
                    </v-chip>
                  </template>

                  <!-- <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-4">
                      <div class="text-subtitle-1 py-1">Linked IPCR</div>
                      <div v-if="item.linkedIPCR.length > 0">
                        <v-data-table
                          :headers="linked_headers"
                          :items="item.linkedIPCR"
                          hide-default-footer
                        >
                        </v-data-table>
                      </div>
                      <div
                        v-if="item.linkedIPCR.length == 0"
                        class="text-center"
                      >
                        <div class="text-caption"><i>No linked IPCR</i></div>
                      </div>
                    </td>
                  </template> -->
                  <template
                    v-slot:[`item.action`]="{ item }"
                    v-if="shouldSubmit()"
                  >
                    <v-btn
                      v-if="
                        shouldSubmit() &&
                        hasUnOpennedRemarks(item.pending_remarks)
                      "
                      x-small
                      class="my-1"
                      @click="showPendingRemarks(item.pending_remarks)"
                      outlined
                      color="primary"
                      block
                      >Show Remarks</v-btn
                    >
                    <v-btn
                      :block="tab != 3"
                      v-if="tab != 3"
                      x-small
                      @click="edit(item)"
                      class="my-1"
                      outlined
                      color="#519043"
                      >Update {{ tab == 2 ? "Success Indicator" : "" }}</v-btn
                    >

                    <v-btn
                      :block="tab != 3"
                      v-if="
                        tab == 2 &&
                        item.isDistributed &&
                        getPositionToTag.canTag
                      "
                      x-small
                      @click="tag(item)"
                      outlined
                      class="my-1"
                      color="#519043"
                      >Tag</v-btn
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <!-- <v-row v-if="isSubmitted && assessed_by_status == 2">
              <v-col cols="12">
                <v-divider></v-divider>
                <div class="pa-3">
                  <div class="text-h6">
                    Comments and Recommendations for Development Purposes:
                  </div>
                  <div class="text-justify text-subtitle-1">
                    {{ targetRating.comments }}
                  </div>
                </div>
              </v-col>
            </v-row> -->
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <!-- <v-fab-transition v-if="isSubmitted">
            <v-menu top>
              <template v-slot:activator="{ on }">
                <v-btn color="#519043" left outlined v-on="on"> Remarks </v-btn>
              </template>

              <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                <v-card-title class="dialog-header white--text">
                  <span class="text-h6">Remarks</span>
                </v-card-title>
                <v-card-text
                  class="py-0"
                  style="
                    background-color: white;
                    height: 300px;
                    overflow-y: auto;
                  "
                >
                  <v-timeline dense v-if="remarksData.length > 0">
                    <v-timeline-item
                      v-for="item in remarksData"
                      :key="item.id"
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-h6">
                          {{
                            $store.getters.getUserData.id ==
                            item.remarks_maker_userID
                              ? "You"
                              : item.remarks_by
                          }}
                        </div>
                        <div class="text-body-1">
                          {{ item.message }}
                        </div>
                        <div class="text-caption">
                          <i>{{ formatDate(item.created_at) }}</i>
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                  <v-timeline dense v-if="remarksData.length == 0">
                    <v-timeline-item
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-body-1">No remarks found.</div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-fab-transition> -->
          <v-spacer></v-spacer>

          <v-btn color="red" outlined @click="closeD()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>

          <v-btn
            v-if="shouldSubmit()"
            color="#519043"
            class="white--text"
            @click="submitTarget()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()"> Close </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSubmitDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to submit this
              <b>Targets for Approval</b>?<br />
              <!-- Please note that
              <b>this action is irreversible.</b> -->
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="confirmBtnLoading"
            color="red"
            outlined
            @click="cancelConfirm()"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="confirmBtnLoading"
            :loading="confirmBtnLoading"
            color="green"
            class="white--text"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- tagging -->
    <v-dialog
      v-model="taggingDialog"
      eager
      persistent
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>{{ isTargetNeedForTagging ? "Distribute Targets" : "" }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="taggingDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 700px" class="my-4">
          <v-form ref="TargetDialogRef" @submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="12" v-if="isTargetNeedForTagging">
                  <v-text-field
                    label="Targets to Distribute"
                    outlined
                    v-model="target_to_distribute"
                    dense
                    readonly
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <div class="pa-2 rounded-lg" style="border: 1px solid grey">
                    <div class="d-flex justify-space-between my-4">
                      <div class="text-body-1">
                        {{ getPositionToTag.label }}
                        <strong>{{ getPositionToTag.toTag }}</strong>
                      </div>
                      <div class="text-subtitle-1 px-2">
                        <v-btn
                          @click="add_head_tagging()"
                          class="white--text rounded-lg"
                          color="#519043"
                        >
                          Add
                        </v-btn>
                      </div>
                    </div>

                    <v-data-table
                      :headers="tagged_head_headers"
                      :items="tagged_head_data"
                      hide-default-footer
                    >
                      <template
                        v-slot:[`item.target`]="{ item }"
                        v-if="isTargetNeedForTagging"
                      >
                        <div>
                          {{
                            sdp_target_format == "numeric"
                              ? item.target
                              : item.target + "%"
                          }}
                        </div>
                      </template>

                      <template v-slot:[`item.action`]="{ item, index }">
                        <v-btn
                          x-small
                          class="mt-1"
                          @click="edit_tag(item, index)"
                          outlined
                          color="warning"
                          block
                          >EDIT</v-btn
                        >
                        <v-btn
                          x-small
                          class="mt-1"
                          @click="untag(item)"
                          outlined
                          color="red"
                          block
                          >Untag</v-btn
                        >
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="taggingDialog = false">
            <v-icon>mdi-close-circle-outline</v-icon>
            Cancel
          </v-btn>

          <v-btn
            color="#519043"
            class="white--text"
            @click="saveTagging()"
            :loading="taggingBtnLoading"
            :disabled="taggingBtnLoading"
          >
            <v-icon>mdi-check-circle</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- heads users dialog-->
    <v-dialog
      v-model="headsDialog"
      eager
      persistent
      scrollable
      max-width="700px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span
            >Select {{ isTargetNeedForTagging ? "Head/Office" : "Personnel" }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeHeadsDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 700px" class="my-4">
          <v-form ref="HeadsDialogRef" @submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="tagged_head_temp_data"
                    dense
                    chips
                    :label="
                      isTargetNeedForTagging ? 'Head/Office' : 'Personnel'
                    "
                    outlined
                    class="rounded-lg"
                    item-text="name"
                    item-value="usID"
                    color="#93CB5B"
                    :items="tempHeadsList"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        small
                        @click="data.select"
                        @click:close="removeTaggedOnClick(data.item)"
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item.name"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="data.item.office"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" v-if="isTargetNeedForTagging">
                  <v-text-field
                    v-model="head_target"
                    type="number"
                    :rules="isTargetNeedForTagging ? [formRules.required] : []"
                    dense
                    outlined
                    required
                    label="Target"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="closeHeadsDialog()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Cancel
          </v-btn>
          <v-btn
            color="#519043"
            class="white--text"
            v-if="tagHeadAction == 'Add'"
            :loading="targetBtnLoading"
            :disabled="targetBtnLoading"
            @click="saveTaggedHeads()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Add
          </v-btn>
          <v-btn
            color="#519043"
            class="white--text"
            v-if="tagHeadAction == 'Update'"
            @click="updateTaggedHeads()"
            :loading="targetBtnLoading"
            :disabled="targetBtnLoading"
          >
            <v-icon>mdi-check-circle</v-icon>
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- untag dialog -->
    <v-dialog
      v-if="unTagDialog"
      v-model="unTagDialog"
      persistent
      max-width="390"
    >
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to untag
              <strong>{{ unTagUser.head_user.name }}</strong> ?<br />
              <!-- Please note that
              <b>this action is irreversible.</b> -->
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="confirmBtnLoading"
            :loading="confirmBtnLoading"
            color="red"
            outlined
            @click="cancelUntag()"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="confirmBtnLoading"
            :loading="confirmBtnLoading"
            color="green"
            class="white--text"
            @click="confirmUntag()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddOPCRTargetsDialog
      :data="opcrData"
      :action="action"
      :opcrID="id"
      :myTaggingType="myTaggingType"
    />
    <UpdateStategicTargetSuccessIndicatorDialog
      :data="opcr1Data"
      :action="action"
      :opcrID="id"
    />
    <UpdateSupportFunctionDialog
      :data="opcrSupData"
      :action="action"
      :opcrID="id"
    />

    <ViewRemarksTimelineDialog
      :data="pendingList"
      :viewFrom="'Owner'"
      v-on:closeRemarksTimeline="initialize()"
    />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import ViewRemarksTimelineDialog from "../../Views/ViewRemarksTimelineDialog.vue";
import UpdateStategicTargetSuccessIndicatorDialog from "./UpdateStategicTargetSuccessIndicatorDialog.vue";

export default {
  components: {
    AddOPCRTargetsDialog: () => import("../OPCR/AddOPCRTargetsDialog.vue"),
    UpdateSupportFunctionDialog: () =>
      import("../OPCR/UpdateOPCRSupportFunctionDialog.vue"),
    // AddIPCRSupportUtilDialog: () =>
    //   import("../Forms/AddIPCRSupportUtilDialog.vue"),
    ViewRemarksTimelineDialog,
    UpdateStategicTargetSuccessIndicatorDialog,
  },
  props: {
    data: null,
  },
  data() {
    return {
      pendingList: [],
      remarksData: [],
      taggingDialog: false,
      taggingBtnLoading: false,
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
      ],
      opcrData: null,
      opcr1Data: null,
      opcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      ipcrSupport: null,
      dataItem: [],
      expanded: [],
      isButtonLoading: false,
      tagged_head_data: [],
      head_target: null,
      tagged_head_headers: [
        {
          text: "Name",
          value: "head_user.name",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Office",
          value: "head_user.office",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Targets",
          value: "target",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          width: 200,
        },
      ],
      cf_headers: [
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Is A Tagged Target",
          value: "is_tagged",
          align: "center",
          valign: "center",
          sortable: false,
        },

        // {
        //   text: "Rating",
        //   value: "eqt",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],
      sp_headers: [
        {
          text: "Code",
          value: "code",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Is Distributed",
          value: "isDistributed",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],
      usersList: [],
      linked_headers: [
        {
          text: "Employee",
          value: "name",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          valign: "center",
          sortable: false,
        },
      ],
      support_headers: [
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "center",

          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
      itemForTagging: null,
      tagIdxToUpdate: null,
      target_to_distribute: null,
      tempHeadsList: [],
      taggingType: null,
      tagHeadAction: null,
      headsDialog: false,
      tagged_head_temp_data: null,
      targetBtnLoading: false,
      unTagUser: null,
      unTagDialog: false,
      untagList: [],
      sdp_target_format: null,
      myTaggingType: null,
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("DSASD", data);
        this.isSubmitted = data.target_submission.is_submitted;
        // this.assessed_by = this.toTitleCase(data.assessed_by_name);
        this.assessed_by_status = data.imm_approval_status;
        this.id = data.id;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.tab = 1;
        this.initialize();
        this.getHeadUsers();
        this.getMyTaggingType();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    console.log("employee ", this.$store.state.emp);
    this.eventHub.$on("closeAddOPCRTargetsDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeUpdateOPCRSupportFunctionDialog", () => {
      this.initialize();
    });
    this.eventHub.$on(
      "closeUpdateStrategicTargetSuccessIndicatorDialog",
      () => {
        this.initialize();
      }
    );
    // this.eventHub.$on("closeUpdateSupportFunctionDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closeAddIPCRSupportUtilDialog", () => {
    //   this.initialize();
    // });
  },
  computed: {
    getCurrentTaggedTotal() {
      let total = 0;
      for (let i = 0; i < this.tagged_head_data.length; i++) {
        total += parseInt(this.tagged_head_data[i].target);
      }
      return total;
    },

    getPositionToTag() {
      let toTag = "";
      let label = "";
      let canTag = true;
      if (this.myTaggingType && this.myTaggingType.type == "vp") {
        label = "Tag to";
        if (this.myTaggingType.office_type != "academic affairs") {
          toTag = "Directors";
        } else {
          toTag = "Deans/Directors";
        }
      } else if (this.myTaggingType && this.myTaggingType.type == "director") {
        label = "Tag to";
        toTag = "Unit Heads";
      } else if (this.myTaggingType && this.myTaggingType.type == "dean") {
        canTag = false;
        label = "Tag to";
        toTag = "Program Chairpersons";
      } else if (this.myTaggingType && this.myTaggingType.type == "unit_head") {
        label = "Tag to";
        toTag = "Personnel/s";
      } else if (
        this.myTaggingType &&
        this.myTaggingType.type == "prog_chair"
      ) {
        canTag = false;
        label = "Tag to";
        toTag = "Faculty/Faculties";
      }
      return {
        label,
        toTag,
        canTag,
      };
    },
    isTargetNeedForTagging() {
      let needed = true;

      if (this.myTaggingType && this.myTaggingType.type == "unit_head") {
        needed = false;
      } else if (
        this.myTaggingType &&
        this.myTaggingType.type == "prog_chair"
      ) {
        needed = false;
      }
      return needed;
    },
  },
  beforeDestroy() {
    this.eventHub.$off("closeAddOPCRTargetsDialog");
    this.eventHub.$off("closeUpdateOPCRSupportFunctionDialog");
    this.eventHub.$off("closeUpdateStrategicTargetSuccessIndicatorDialog");
    // this.eventHub.$off("closeMPORDialog");
    // this.eventHub.$off("closeUpdateSupportFunctionDialog");
  },

  methods: {
    initialize() {
      this.loading = true;
      this.loadRemarks(this.data.target_submission.id);

      this.axiosCall(
        "/opcr-target/getMyOPCRTargetBy/" + this.data.id + "/" + this.tab,
        "GET"
      ).then((res) => {
        if (res) {
          console.log("Init", res.data);
          this.dataItem = res.data;
          this.loading = false;
        }
      });
    },

    setPendingClass(item) {
      if (this.tab != 3) {
        let list = item.pending_remarks;
        let has = false;
        if (list) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].isOpenned == 0) {
              has = true;
              break;
            }
          }
          if (has) {
            return "red lighten-4";
          }
        }
        return "";
      }

      return "";
    },

    hasUnOpennedRemarks(list) {
      if (list && list.length > 0) {
        let has = false;
        for (let i = 0; i < list.length; i++) {
          if (list[i].isOpenned == 0) {
            has = true;
            break;
          }
        }
        if (has) {
          return has;
        } else {
          if (this.shouldSubmit()) {
            return true;
          }
        }
      } else {
        return false;
      }
    },

    showPendingRemarks(item) {
      this.pendingList = [];
      setTimeout(() => {
        this.pendingList = item;
      }, 100);
    },

    getUserName(id) {
      console.log("UID", id);
      let idx = this.usersList.findIndex((el) => el.usID == id);

      return this.usersList[idx].name;
    },

    shouldSubmit() {
      if (this.isSubmitted == 0) {
        return true;
      } else {
        if (this.data) {
          let approval_arr = [
            this.data.target_submission.imm_approval_status,
            this.data.target_submission.planning_user_approval_status,
            this.data.target_submission.cpmt_approval_status,
            this.data.target_submission.cpmt_head_approval_status,
            this.data.target_submission.president_approval_status,
          ];
          console.log("APPROVL ARR", approval_arr);
          if (approval_arr.includes(3)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/OPCR_TARGET_APPROVAL", "GET").then(
          (res) => {
            if (res.data) {
              console.log("remarks", res.data);
              this.remarksData = res.data;
            }
          }
        );
      }
    },
    closeD() {
      this.eventHub.$emit("closeOPCRTargetDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    edit(item) {
      if (this.tab != 3) {
        if (this.tab == 1) {
          this.opcrData = item;
        } else {
          this.opcr1Data = item;
        }
        this.action = "Update";
      } else {
        this.opcrSupData = item;
        this.action = "Update";
      }
    },

    getMyFilteredUserList() {
      let filtered = [];
      let off = this.$store.state.emp.officeID;
      // console.log(
      //   "OFF",
      //   off,
      //   this.myTaggingType.office_type,
      //   this.myTaggingType.type
      // );
      if (this.myTaggingType && this.myTaggingType.type == "vp") {
        for (let i = 0; i < this.usersList.length; i++) {
          if (this.myTaggingType.office_type != "academic affairs") {
            if (
              this.usersList[i].office_underID == off &&
              this.usersList[i].roleID == 7
            ) {
              filtered.push(this.usersList[i]);
            }
          } else {
            if (
              this.usersList[i].office_underID == off &&
              (this.usersList[i].roleID == 7 || this.usersList[i].roleID == 8)
            ) {
              filtered.push(this.usersList[i]);
            }
          }
        }
      } else if (this.myTaggingType.type == "director") {
        for (let i = 0; i < this.usersList.length; i++) {
          if (this.myTaggingType.office_type == "admin and finance") {
            if (
              this.usersList[i].office_underID == off &&
              (this.usersList[i].roleID == 9 || this.usersList[i].roleID == 1)
            ) {
              filtered.push(this.usersList[i]);
            }
          } else {
            if (
              this.usersList[i].office_underID == off &&
              this.usersList[i].roleID == 9
            ) {
              filtered.push(this.usersList[i]);
            }
          }
        }
      } else if (this.myTaggingType.type == "dean") {
        for (let i = 0; i < this.usersList.length; i++) {
          if (
            (this.usersList[i].office_underID == off ||
              this.usersList[i].officeID == off) &&
            this.usersList[i].roleID == 12
          ) {
            filtered.push(this.usersList[i]);
          }
        }
      } else if (
        this.myTaggingType.type == "unit_head" ||
        this.myTaggingType.type == "prog_chair"
      ) {
        for (let i = 0; i < this.usersList.length; i++) {
          if (
            (this.usersList[i].office_underID == off ||
              this.usersList[i].officeID == off) &&
            this.usersList[i].roleID == 2
          ) {
            filtered.push(this.usersList[i]);
          }
        }
      }

      return filtered;
    },

    tag(item) {
      this.itemForTagging = item;
      this.taggingType = item.taggingType;
      console.log(this.myTaggingType.type, item);
      if (
        // this.myTaggingType.type == "prog_chair" ||
        this.myTaggingType.type == "unit_head"
      ) {
        this.axiosCall(
          "/opcr-target/getTaggedPersonnel/" +
            item.OpcrPapTargetDistributedTaggingID +
            "/" +
            this.myTaggingType.type +
            "/sp",
          "GET"
        ).then((res) => {
          let data = res.data;
          console.log("asdasd", res.data);
          for (let i = 0; i < data.length; i++) {
            data[i].head_user.name = this.toTitleCase(data[i].head_user.name);
          }
          this.tagged_head_data = data;
        });

        this.taggingDialog = true;
      } else {
        this.sdp_target_format = item.sdp_target_format;

        if (this.myTaggingType.type != "vp") {
          this.target_to_distribute =
            item.sdp_target_format == "numeric"
              ? item.tagged_target
              : item.tagged_target + "%";
        } else {
          this.target_to_distribute =
            item.sdp_target_format == "numeric"
              ? item.target
              : item.target + "%";
        }
        this.tagged_head_data = [];
        this.taggingDialog = true;

        this.axiosCall(
          "/opcr-target/getTaggedOffices/" +
            item.id +
            "/" +
            this.myTaggingType.type +
            "/sp",
          "GET"
        ).then((res) => {
          let data = res.data;
          for (let i = 0; i < data.length; i++) {
            data[i].head_user.name = this.toTitleCase(data[i].head_user.name);
          }
          this.tagged_head_data = data;
        });
      }
    },

    add_head_tagging() {
      this.tagHeadAction = "Add";

      if (this.tagged_head_data.length > 0) {
        let list = this.getMyFilteredUserList();
        for (let i = 0; i < this.tagged_head_data.length; i++) {
          for (let j = 0; j < list.length; j++) {
            if (this.tagged_head_data[i].head_user.usID == list[j].usID) {
              list.splice(j, 1);
              break;
            }
          }
        }
        this.tempHeadsList = list;
      } else {
        this.tempHeadsList = this.getMyFilteredUserList();
      }

      console.log("tagging list", this.tempHeadsList);
      this.tagged_head_temp_data = null;
      this.head_target = null;
      this.headsDialog = true;
    },

    removeTaggedOnClick(item) {
      this.tagged_head_temp_data = null;
      console.log("REMOVED ON LCIK", item);
      for (let i = 0; i < this.tagged_head_data.length; i++) {
        if (this.tagged_head_data[i].head_user.usID == item.head_user.usID) {
          if (!item.opcrPapTargetDistributedTaggingID) {
            this.tagged_head_data.splice(i, 1);
          } else {
            this.untagList.push(this.tagged_head_data[i]);
            this.tagged_head_data.splice(i, 1);
          }
        }
      }
    },

    edit_tag(item, index) {
      // this.getHeadUsers();
      console.log(item, index);
      let allHeadList = this.getMyFilteredUserList();
      console.log("TEMPHEAD", allHeadList);
      // setTimeout(() => {
      let tempTaggedHeads = [];
      if (this.tagged_head_data.length > 1) {
        for (let i = 0; i < this.tagged_head_data.length; i++) {
          if (this.tagged_head_data[i].head_user.usID != item.head_user.usID) {
            tempTaggedHeads.push(this.tagged_head_data[i]);
          }
        }

        if (tempTaggedHeads.length > 0) {
          let list = this.getMyFilteredUserList();
          for (let i = 0; i < tempTaggedHeads.length; i++) {
            for (let j = 0; j < list.length; j++) {
              if (tempTaggedHeads[i].head_user.usID == list[j].usID) {
                list.splice(j, 1);
                break;
              }
            }
          }
          this.tempHeadsList = list;
        }
      } else {
        this.tempHeadsList = allHeadList;
      }

      this.tagIdxToUpdate = index;
      this.tagHeadAction = "Update";

      this.head_target = item.target;
      if (typeof item.head_user.usID == "number") {
        this.tagged_head_temp_data = item.head_user.usID.toString();
      } else {
        this.tagged_head_temp_data = item.head_user.usID;
      }

      this.headsDialog = true;
      // }, 100);
    },

    untag(item) {
      this.unTagUser = item;
      this.unTagDialog = true;
    },

    confirmUntag() {
      // console.log(this.unTagUser);
      this.removeTaggedOnClick(this.unTagUser);
      this.unTagUser = null;
      this.unTagDialog = false;
    },
    cancelUntag() {
      this.unTagUser = null;
      this.unTagDialog = false;
    },

    closeHeadsDialog() {
      this.tagHeadAction = null;
      this.headsDialog = false;
    },

    saveTaggedHeads() {
      if (this.isTargetNeedForTagging) {
        let todistribute;
        let target_to_distribute = this.target_to_distribute.toString();

        if (target_to_distribute.includes("%")) {
          todistribute = this.target_to_distribute.slice(0, -1);
        } else {
          todistribute = this.target_to_distribute;
        }
        if (this.getCurrentTaggedTotal <= todistribute) {
          let tempT =
            parseInt(this.getCurrentTaggedTotal) + parseInt(this.head_target);
          if (tempT <= todistribute) {
            for (let j = 0; j < this.usersList.length; j++) {
              if (this.tagged_head_temp_data == this.usersList[j].usID) {
                this.tagged_head_data.push({
                  head_user: this.usersList[j],
                  target: this.head_target,
                });
                break;
              }
            }
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message =
              "Total tagged targets exceeded the target to distribute!";
          }
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message =
            "Total tagged targets exceeded the target to distribute!";
        }
      } else {
        for (let j = 0; j < this.usersList.length; j++) {
          if (this.tagged_head_temp_data == this.usersList[j].usID) {
            this.tagged_head_data.push({
              head_user: this.usersList[j],
              target: null,
            });
            break;
          }
        }
      }

      this.closeHeadsDialog();
    },

    updateTaggedHeads() {
      for (let j = 0; j < this.usersList.length; j++) {
        if (this.tagged_head_temp_data == this.usersList[j].usID) {
          this.tagged_head_data[this.tagIdxToUpdate].head_user =
            this.usersList[j];
          this.tagged_head_data[this.tagIdxToUpdate].target = this.head_target;
          break;
        }
      }
      this.tagIdxToUpdate = null;
      this.closeHeadsDialog();
    },

    saveTagging() {
      if (this.isTargetNeedForTagging) {
        let todistribute;
        let target_to_distribute = this.target_to_distribute.toString();
        if (target_to_distribute.includes("%")) {
          todistribute = this.target_to_distribute.slice(0, -1);
        } else {
          todistribute = this.target_to_distribute;
        }

        if (this.getCurrentTaggedTotal == parseInt(todistribute)) {
          this.taggingBtnLoading == true;
          let data = {
            taggingType: this.taggingType,
            opcrPapTargetDistributedTaggingID: this.itemForTagging
              .OpcrPapTargetDistributedTaggingID
              ? this.itemForTagging.OpcrPapTargetDistributedTaggingID
              : null,
            idToTag: this.itemForTagging.id,
            tagged_head_data: JSON.stringify(this.tagged_head_data),
            untagList: JSON.stringify(this.untagList),
          };
          console.log(data);

          this.axiosCall("/opcr-target/save-sp-tagging", "POST", data).then(
            (res) => {
              if (res.data.status == 201) {
                this.taggingDialog = false;
                this.taggingBtnLoading = false;
                this.itemForTagging = null;
                this.tagged_head_data = [];
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "success";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
              } else {
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = "error";
                this.fadeAwayMessage.header = "System Message";
                this.fadeAwayMessage.message = res.data.msg;
                this.taggingBtnLoading = false;
              }
            }
          );
        } else {
          if (this.getCurrentTaggedTotal > parseInt(todistribute)) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message =
              " Total tagged targets exceeded the target to distribute!";
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message =
              "Please tag director/heads accordingly!";
          }
        }
      } else {
        this.taggingBtnLoading == true;
        let data = {
          taggingType: this.taggingType,
          opcrPapTargetDistributedTaggingID: this.itemForTagging
            .OpcrPapTargetDistributedTaggingID
            ? this.itemForTagging.OpcrPapTargetDistributedTaggingID
            : null,
          idToTag: this.itemForTagging.id,
          tagged_head_data: JSON.stringify(this.tagged_head_data),
          typeOfTarget: "sp",
          untagList: JSON.stringify(this.untagList),
        };

        this.axiosCall(
          "/opcr-target/save-opcr-to-ipcr-tagging",
          "POST",
          data
        ).then((res) => {
          if (res.data.status == 201) {
            this.taggingDialog = false;
            this.taggingBtnLoading = false;
            this.itemForTagging = null;
            this.tagged_head_data = [];
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.taggingBtnLoading = false;
          }
        });
      }
    },

    submitTarget() {
      this.confirmSubmitDialog = true;
    },

    confirmSubmit() {
      this.confirmBtnLoading = true;
      // this.isSubmitLoading = true;
      this.axiosCall("/opcr-target/submitTargets/" + this.id, "PATCH").then(
        (res) => {
          if (res.data.status == 200) {
            this.confirmBtnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      );
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },

    AddFunction() {
      this.opcrData = { id: null, year: this.data.year };
      this.action = "Add";
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    // confirmDelete() {
    //   this.isButtonLoading = true;
    //   this.axiosCall(
    //     "/ipcr-target/deleteTarget/" + this.itemToDelete.id,
    //     "DELETE"
    //   ).then((res) => {
    //     if (res.data.status == 200) {
    //       this.confirmDialog = false;
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "success";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.isButtonLoading = false;
    //       this.itemToDelete = null;
    //       this.confirmDialog = false;

    //       this.initialize();
    //     } else {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.isButtonLoading = false;
    //     }
    //   });
    // },

    getHeadUsers() {
      this.axiosCall(
        "/user-details/getUsersHeadProgChairAbove_Office",
        "GET"
      ).then((res) => {
        let data = res.data;
        data.forEach((element, i) => {
          data[i].name = this.toTitleCase(element.name);
        });
        this.usersList = data;
        console.log("USERS", res.data);
      });
    },

    getMyTaggingType() {
      this.axiosCall("/opcr-target/getMyTaggingType", "GET").then((res) => {
        this.myTaggingType = res.data;
      });
    },
  },
};
</script>
<style scoped></style>
